import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

function AppNavbar() {
    const [expanded, setExpanded] = useState(false);

    // Close navbar after clicking a link
    const handleNavClick = () => setExpanded(false);

    return (
        <Navbar
            bg="primary"
            variant="dark"
            expand="lg"
            sticky="top"
            className="shadow-sm"
            expanded={expanded}
        >
            <Container>
                <LinkContainer to="/" onClick={handleNavClick}>
                    <Navbar.Brand className="d-flex align-items-center">
                        <img
                            src="/assets/images/logo.jpg"
                            alt="Shiny Squad Cleaning Logo"
                            style={{ height: '40px', marginRight: '10px' }}
                        />
                        Shiny Squad Cleaning
                    </Navbar.Brand>
                </LinkContainer>

                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setExpanded(expanded ? false : "expanded")}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        {[
                            { to: '/', label: 'Home', end: true },
                            { to: '/about', label: 'About' },
                            { to: '/listings', label: 'Listings' },
                            { to: '/contact', label: 'Contact' },
                        ].map(({ to, label, end }) => (
                            <LinkContainer key={to} to={to} exact={end} onClick={handleNavClick}>
                                <Nav.Link>{label}</Nav.Link>
                            </LinkContainer>
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default AppNavbar;
